/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import { verifyCredentialProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "ProvenanceDetailPageService";
const log: any = LoggerModule.getInstance();

export class ProvenanceDetailPageService {
  private static instance: ProvenanceDetailPageService;
  private vapp: VApplication;
  private verifyCredentialRestAPI: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.verifyCredentialRestAPI = props?.verifyCredentialRestAPI;
  }

  public static getInstance(props: any = {}): ProvenanceDetailPageService {
    if (!ProvenanceDetailPageService.instance) {
      ProvenanceDetailPageService.instance = new ProvenanceDetailPageService(props);
    }
    return ProvenanceDetailPageService.instance;
  }

  //private instances

  //------------------------------------

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async verifyCredential(args: verifyCredentialProps) {
    console.log(` in index of service :`, args);
    let _args = {
      ...args,
      apiURL: this.verifyCredentialRestAPI,
    };
    const agent = getAgent();
    return agent.verifyCredential(_args);
  }
}
